export default __webpack_public_path__ + "static/media/img-52.780cc545.jpg";